import React from 'react';
import Textfield from '../../components/textField/TextField';
import TextArea from '../../components/textField/TextArea';
import { Row, Col } from 'react-bootstrap';
import Checkbox from '../../components/checkBox/Checkbox';
import RadioBtn from '../../components/RadioBtn';
import moment from 'moment';
import SubDynamicColumn from './SubDynamicColumn';
import Select, { components } from 'react-select';
import Datepicker from '../../components/textField/Datepicker';

const { ValueContainer, Placeholder }: any = components;
const CustomValueContainer: React.FC<any> = ({ children, ...props }) => {
    return (
        <ValueContainer {...props}>
            <Placeholder {...props} isFocused={props.isFocused}>
                {props.selectProps.placeholder}
            </Placeholder>
            {React.Children.map(children, (child) =>
                child && child.type !== Placeholder ? child : null
            )}
        </ValueContainer>
    );
};

type fetchDynamicColumnProps = {
    data: any;
    fetchSubDynamicColumn: any,
    getDynamicInputColumnValue: any,
}

const FetchDynamicColumn: React.FC<fetchDynamicColumnProps> = ({ data, fetchSubDynamicColumn, getDynamicInputColumnValue }) => {

    const getDynamicColumn = (data: any) => {

        switch (data.ColumnType) {
            case "COMBO":
                return <Select
                    placeholder={`${data.LabelName} ${data.Required === "Y" ? "*" : ""}`}
                    options={[{ value: "", label: `Select ${data.LabelName}`, ColumnVal: "" }, ...data.ComboOption.map((items: any) => ({
                        value: items.SrCode, label: items.LabelName, ColumnVal: items.ColumnVal
                    }))]}
                    className="select-form"
                    tabIndex={3}
                    required={data.Required === "Y"}
                    onChange={(e: any) => {
                        data.flag === "F" ? getDynamicInputColumnValue(data.ColumnCode, e.ColumnVal) : fetchSubDynamicColumn(data.ColumnCode, e.value, e.ColumnVal, "D");
                    }}
                    components={{
                        ValueContainer: CustomValueContainer
                    }}
                    styles={{
                        valueContainer: (provided, state) => ({
                            ...provided,
                            overflow: "visible"
                        }) as any,
                        placeholder: (provided, state) => ({
                            ...provided,
                            position: "absolute",
                            paddingRight: 3,
                            paddingLeft: 3,
                            top: state.hasValue || state.selectProps.inputValue ? -11 : "13%",
                            backgroundColor:
                                state.hasValue || state.selectProps.inputValue
                                    ? "white"
                                    : "transparent",
                            transition: "top 0.3s, font-size 0.3s",
                            fontSize: (state.hasValue || state.selectProps.inputValue) && 12
                        }) as any
                    }}
                />;
            case "INPUT":
                return <Textfield
                    label={data.LabelName}
                    name={data.LabelName}
                    id={data.LabelName}
                    size="small"
                    tabIndex={3}
                    minLength={Number(data.MinLength)}
                    maxLength={Number(data.MaxLength)}
                    value={data.ColumnValue}
                    required={data.Required === "Y"}
                    onChange={(e) => {
                        getDynamicInputColumnValue(data.ColumnCode, e.target.value);
                    }}
                />;
            case "TEXT":
                return <TextArea
                    label={data.LabelName}
                    name={data.LabelName}
                    id={data.LabelName}
                    size="small"
                    tabIndex={3}
                    minLength={Number(data.MinLength)}
                    maxLength={Number(data.MaxLength)}
                    value={data.ColumnValue}
                    required={data.Required === "Y"}
                    onChange={(e) => {
                        getDynamicInputColumnValue(data.ColumnCode, e.target.value);
                    }}
                />;
            case "CHECK":
                return <Checkbox
                    label={data.LabelName}
                    name={data.LabelName}
                    value={data.ColumnValue}
                    checked={data.ColumnValue === "Y"}
                    onChange={(e: any) => {
                        const value = e.target.checked ? "Y" : "N"
                        getDynamicInputColumnValue(data.ColumnCode, value);
                    }}
                />;
            case "NUMBER":
                return <Textfield
                    label={data.LabelName}
                    name={data.LabelName}
                    id={data.LabelName}
                    size="small"
                    tabIndex={3}
                    minLength={Number(data.MinLength)}
                    maxLength={Number(data.MaxLength)}
                    value={data.ColumnValue}
                    required={data.Required === "Y"}
                    onChange={(e: any) => {
                        const { value } = e.target;
                        const regex = /^[0-9]*[.,]?[0-9]*$/;
                        if (regex.test(value.toString())) {
                            getDynamicInputColumnValue(data.ColumnCode, value);
                        }
                    }}
                />;
            case "RADIO":
                return <div>
                    <label className={`form-label text-xs mb-0 ${data.Required === "Y" && "required"}`}>{data.LabelName}</label>
                    <div className="d-flex">
                        {data.ComboOption.map((items: any, index: number) => {
                            return (
                                <RadioBtn
                                    key={index}
                                    label={items.LabelName}
                                    name={data.ColumnCode}
                                    id={items.ColumnCode}
                                    className="me-3"
                                    value={data.ColumnValue}
                                    checked={items.ColumnVal === data.ColumnValue}
                                    onChange={(e: any) => {
                                        fetchSubDynamicColumn(data.ColumnCode, items.SrCode, items.ColumnVal, "D");
                                    }}
                                />
                            )
                        })}
                    </div>
                </div>;
            case "DATE":
                return <div>
                    <Datepicker
                        label={data.LabelName}
                        className="form-control"
                        size="small"
                        tabIndex={3}
                        options={{
                            dateFormat: "d/m/Y",
                            minDate: moment().subtract(Number(data.MinLength), 'days').format('DD/MM/YYYY'),
                            maxDate: moment().add(Number(data.MaxLength), 'days').format('DD/MM/YYYY'),
                        }}
                        // placeholder={data.LabelName}
                        name='dateRange'
                        value={data.ColumnValue}
                        onChange={(e: any) => {
                            getDynamicInputColumnValue(data.ColumnCode, e[0]);
                        }}
                    />
                </div>;
        }
    };

    return (
        <Row>
            {data?.map((items: any, id: any) => {
                return (
                    <React.Fragment key={id}>
                        <Col md={6} lg={6} className='mt-3'>
                            {getDynamicColumn(items)}
                        </Col>
                        {items?.SubDynamicColumnData?.map((data: any, index: number) => (
                            <SubDynamicColumn data={data} fetchSubDynamicColumn={fetchSubDynamicColumn} key={index} />
                        ))}
                    </React.Fragment>
                )
            })}
        </Row >
    )
}

export default FetchDynamicColumn
